import { Loader2 } from 'lucide-react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import type { IMessageTemplate } from '@/@types/messageTemplates';

interface ITemplateDeleteConfirmProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  template?: IMessageTemplate;
  isDeleting: boolean;
  onDelete: () => void;
}

export function TemplateDeleteConfirm({
  open,
  onOpenChange,
  template,
  isDeleting,
  onDelete,
}: ITemplateDeleteConfirmProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Template</AlertDialogTitle>
          <AlertDialogDescription>
            {template?.sharedWithBusinessIds.length
              ? `This template is shared with ${template.sharedWithBusinessIds.length} business(es). Deleting will remove their access.`
              : 'Are you sure you want to delete this template? This action cannot be undone.'}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isDeleting}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={onDelete}
            disabled={isDeleting}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {isDeleting ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : null}
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
